<div class="navigation">
  <button cbButton label="Save" (click)="goPrev()" [disabled]="currentStep === 1">
    <!-- Disable if on the first step -->
  </button>
</div>
